export const BACKEND_URL: string = "https://staging.easy-dog.me"